export function incompleteAction({landingPageId,cardDesignId,landscapeCardDesignId,portraitCardDesignId,printMode,printerGroupId}) {
 return !landingPageId || (printMode !== 'none' && !(cardDesignId || landscapeCardDesignId || portraitCardDesignId)) || (printMode !== 'none' && !printerGroupId);
}
